var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"show-hide-menu",class:{active: _vm.menuHidden},on:{"click":_vm.toggleSidebar}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'bars']}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }